// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_HxY","cls2":"AppsMegaMenu-cls2_WFw AppsMegaMenu-cls1_HxY"};